export default __webpack_public_path__ + "static/media/word.a15310bd.png";